import { render, staticRenderFns } from "./IntegrationTelegramCard.vue?vue&type=template&id=14001b4c&scoped=true&"
import script from "./IntegrationTelegramCard.vue?vue&type=script&lang=js&"
export * from "./IntegrationTelegramCard.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationTelegramCard.vue?vue&type=style&index=0&id=14001b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14001b4c",
  null
  
)

export default component.exports